function getConfig(node) {
  var tmp = node ? JSON.parse(node.content) : {}

  // Clean up variables
  tmp.translationPath && (tmp.translationPath = tmp.translationPath.trim())

  return tmp
}

/***
 * `config` is only up to date on page load.
 * Call `get()` to use the latest config.
 * Keeping this export due to dependencies in other files.
 */
exports.config = get()

function set(config){
  var meta = document.getElementById('cm-app-config');
  meta.content = JSON.stringify(config);
}

/***
 * Use `get()` when the config has been updated with `set()`.
 * Use `config` only when you need data on page load.
 */
function get(){
  var meta = getConfig(document.getElementById('cm-app-config'))
  return meta
}

exports.set = set;
exports.get = get;
